import { Button } from "@shared/ui/Button";
import { Type } from "@shared/ui/Type";

export type Props = {
  organizationName: string;
  originalPrice: string;
  discountPrice: string;
  onLearnMoreClick: () => void;
};

export function SettingsPlanDetails({
  organizationName,
  originalPrice,
  discountPrice,
  onLearnMoreClick,
}: Props) {
  return (
    <div className="rounded-lg border p-8">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between">
        <div className="space-y-2">
          <Type variant="h4">2025 Pilot Year</Type>
          <Type as="p" variant="body2">
            Your participation is free thanks to {organizationName} and support
            from private and public grantmakers.
          </Type>
          <Button
            variant="secondary"
            className="mt-4 md:mt-6"
            onClick={onLearnMoreClick}
            data-testid="settings-plan-learn-more"
          >
            Learn more
          </Button>
        </div>

        <div className="mt-4 flex flex-col items-baseline gap-2 md:mt-0 md:text-right">
          <div className="flex flex-row gap-2">
            <span className="text-4xl font-semibold text-brand-200 line-through decoration-2">
              ${originalPrice}
            </span>
            <span className="text-4xl font-semibold">${discountPrice}</span>
          </div>
          <Type as="span" variant="caption">
            per program
          </Type>
        </div>
      </div>
    </div>
  );
}

export default SettingsPlanDetails;
